const documentsEn = {
    documentFolder: require('lang/en/documents/Folder').default,
    documentFile: require('lang/en/documents/File').default,
}

export default documentsEn;